module.exports = __webpack_public_path__ + "img/files.8bae80c8.svg";